<script>
import DraggableList from './draggable-list'
import ZTableColumn from './column-functional'
import ZDefaultData from '../common/default-data/main'
import pagination from '../el-pagination'
import { getLastLevel, getHandleColumns, isPlainObject } from './util'
import { getColumnConfig, saveColumnConfig } from '@/server/common'
export default {
  name: 'EditorHeaderTable',
  components: {
    ZTableColumn,
    ZDefaultData,
    [pagination.name]: pagination,
    DraggableList,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    defaultColumns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      required: true,
    },
    selection: {
      type: Boolean,
      default: false,
    },
    tableName: {
      type: String,
      default: '',
    },
    pagination: {
      type: [Boolean, Object],
      default: () => ({
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0, // 全部数据条数
      }),
      validator(val) {
        if (isPlainObject(val)) {
          return 'pageNum' in val && 'pageSize' in val
        }
        return val === false
      },
    },
    autoCalcTableHeight: {
      type: Boolean,
      default: false,
    },
    keepScrollPos: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: Number,
    },
    paginationComponentData: {
      type: Object,
      default: () => ({}),
    },
    fixTableHeaderList: {
      type: Array,
      default: () => [],
    },
    customEmpty: {
      type: Boolean, // 是否展示统一缺省
      default: false,
    },
    customDefault: {
      type: Object, // 自定义统一缺省页
      default: () => ({
        height: '300px',
        img: '',
        title: '',
        text: '',
        buttons: [],
      }),
    },
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      checkList: [],
      page: {},
      tableHeight: null,
      originalScrollPos: 0,
      serverCheckList: [],
      totalCheckList: [],
      allColumnConfig: false,
      configLoading: false,
      tableColumns: [],
    }
  },
  computed: {
    dragOptions() {
      return {
        handle: '.drag-icon',
        dragClass: 'drag-item',
        chosenClass: 'chosenClass',
        forceFallback: true,
        animation: 100,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        scrollSensitivity: 100,
        fallbackTolerance: 1,
        bubbleScroll: true,
        scrollSpeed: 2000,
        scroll: true,
        originalCheckList: [],
      }
    },
    paginationH() {
      return this.pagination ? 80 : 16
    },
    lastColumn() {
      return this.columns.slice(-1).map(i => {
        if (!i.slotHeaderName) {
          return { ...i, slotHeaderName: i.prop + 'Header' }
        }
        return i
      })[0]
    },
    restColumns() {
      return this.columns.slice(0)
    },
    lastLevelColumns() {
      return this.restColumns
    },
    totalColumnConfig() {
      return this.lastLevelColumns.map(i => ({ prop: i.prop, label: i.label, active: true }))
    },
    moreLevel() {
      return this.restColumns.some(i => i.children && i.children.length)
    },
    lastColumnScopedHeader() {
      const { $scopedSlots, lastColumn, tableName, openDrawer } = this
      console.log(tableName, 'tableName')
      if (lastColumn && tableName) {
        const fn =
          $scopedSlots[lastColumn.slotHeaderName] ||
          function (props) {
            return <span>{props.column.label}</span>
          }
        return props => {
          return (
            <div style="display: flex; align-items: center">
              {fn(props)}
              <i class="el-icon-setting fc-primary" style="cursor: pointer; margin-left: 10px" onClick={openDrawer} />
            </div>
          )
        }
      }
      return null
    },
    activeColumns() {
      return this.totalCheckList.filter(i => i.active)
    },
    columnMap() {
      const map = {}
      for (const config of this.restColumns) {
        map[config.prop] = config
      }
      return map
    },
  },
  watch: {
    drawer(val) {
      this.$nextTick(() => {
        const el = document.querySelector('.content-js')
        // console.log(el)
        if (el) {
          el.style.overflow = val ? 'hidden' : 'auto'
        }
      })
    },
    totalCheckList: {
      handler(val) {
        this.allColumnConfig = val.every(config => config.active)
      },
      immediate: true,
      deep: true,
    },
    columns(val) {
      this.getAllColumns()
    },
  },
  created() {},
  mounted() {
    this.getTableHeight()
    this.getAllColumns()
  },
  activated() {
    if (this.keepScrollPos) {
      setTimeout(() => {
        this.resetScrollPos()
      }, 10)
    }
  },
  methods: {
    getTableColumns() {
      if (!this.tableName) return this.restColumns
      const map = this.columnMap
      const columns = []
      this.totalCheckList.forEach(config => {
        if (config.active) {
          columns.push(map[config.prop])
        }
      })
      if (columns.every(i => !i.minWidth)) {
        return columns.map(i => {
          const { width, ...other } = i
          return Object.assign({}, other, width ? { minWidth: width } : {})
        })
      }
      return columns
    },
    resetOriginColumnConfig() {
      this.totalCheckList = JSON.parse(JSON.stringify(this.columns))
    },
    async confirmColumnConfig() {
      if (this.activeColumns.length < 5) {
        return this.$message.error(this.$t('system::common::editorHeader-table::errorTip'))
      }
      const postData = {
        tableName: this.tableName,
        columns: JSON.stringify(this.totalCheckList),
      }
      this.closeDrawer()
      // 保存同步表头数据接口
      const { data } = await saveColumnConfig(postData)
      if (data.code === 0) {
        this.closeDrawer()
        this.tableColumns = this.getTableColumns()
        // this.originalCheckList = JSON.parse(JSON.stringify(this.totalCheckList))
      }
    },
    async getAllColumns() {
      if (!this.tableName) {
        this.tableColumns = this.getTableColumns()
        return
      }
      let list = this.totalColumnConfig
      try {
        // 调接口 获取表头数据 渲染表头
        const { data } = await getColumnConfig({ tableName: this.tableName })
        if (data.code === 0) {
          const obj = data.data || {}
          if (obj.columns) {
            try {
              list = JSON.parse(obj.columns)
              const tmp = []
              const map = {}
              list.forEach(item => {
                if (this.columnMap[item.prop]) {
                  tmp.push(item)
                  map[item.prop] = 1
                }
              })
              this.totalColumnConfig.forEach(i => {
                if (!map[i.prop]) {
                  tmp.push(Object.assign({}, i, { active: false }))
                }
              })
              list = tmp
            } catch (e) {}
          }
        }
      } catch (e) {}
      this.totalCheckList = list
      this.tableColumns = this.getTableColumns()
      // this.originalCheckList = JSON.parse(JSON.stringify(list))
    },
    saveScrollPos() {
      const el = this.$refs.elTable.$el
      if (el) {
        const targetEl = el.querySelector('.el-table__body-wrapper')
        this.originalScrollPos = (targetEl && targetEl.scrollTop) || 0
      }
    },
    resetScrollPos() {
      const el = this.$refs.elTable.$el
      if (el) {
        const targetEl = el.querySelector('.el-table__fixed-body-wrapper')
        const targetEl1 = el.querySelector('.el-table__body-wrapper')
        if (targetEl) {
          targetEl.scrollTop = this.originalScrollPos
        }
        if (targetEl1) {
          targetEl1.scrollTop = this.originalScrollPos
        }
      }
    },
    getTableHeight() {
      if (!this.autoCalcTableHeight) return
      this.$nextTick(() => {
        const el = this.$refs.tableWrap
        if (el) {
          const pos = el.getBoundingClientRect()
          const h = window.innerHeight - pos.top - this.paginationH
          this.tableHeight = h < 100 ? 300 : h
        }
      })
    },
    openDrawer() {
      console.log('开启抽屉')
      this.drawer = true
    },
    closeDrawer() {
      this.drawer = false
    },
    changeCheckList(val) {
      this.checkList = val
    },
    tableRef() {
      return this.$refs.elTable
    },
    findBodyWrapper(el) {
      let target = null
      const f = arr => {
        let dom = null
        for (const item of arr) {
          if (item && item.className && item.className.indexOf('body-wrapper') > 0) {
            dom = item
            break
          } else {
            dom = f(item.childNodes)
            if (dom) {
              break
            }
          }
        }
        return dom
      }
      for (const item of el.children) {
        if (item && item.className && item.className.indexOf('body-wrapper') > 0) {
          target = item
          break
        } else {
          target = f(item.childNodes)
          if (target) {
            break
          }
        }
      }
      return target
    },
    handlePageChange(pageNum) {
      if (this.findBodyWrapper(this.$refs.elTable.$el)) {
        this.findBodyWrapper(this.$refs.elTable.$el).scrollTop = 0
      }
      this.$emit('update:pagination', {
        ...this.pagination,
        pageNum,
      })
      // 页码发生变化
      this.$emit('page-change')
    },
    handlePageSizeChange(pageSize) {
      if (this.findBodyWrapper(this.$refs.elTable.$el)) {
        this.findBodyWrapper(this.$refs.elTable.$el).scrollTop = 0
      }
      this.$emit('update:pagination', {
        ...this.pagination,
        pageNum: 1, // 页码
        pageSize: pageSize, // 每页大小
        total: this.pagination.total, // 全部数据条数
      })
      this.$emit('page-change')
    },
    changeAllCheck(v) {
      this.totalCheckList.forEach(config => {
        if (this.fixTableHeaderList.includes(config.prop)) {
          this.$set(config, 'active', true)
        } else {
          this.$set(config, 'active', v)
        }
      })
    },
  },
  render(h) {
    const {
      confirmColumnConfig,
      resetOriginColumnConfig,
      totalCheckList,
      data,
      $listeners,
      $attrs,
      selection,
      tableName,
      drawer,
      direction,
      closeDrawer,
      $scopedSlots,
      tableColumns,
      columns,
      lastColumn,
      handlePageSizeChange,
      pagination,
      handlePageChange,
      tableHeight,
      autoCalcTableHeight,
      allColumnConfig,
      customEmpty,
      customDefault,
    } = this

    const other = {
      on: $listeners,
      attrs: {
        ...(autoCalcTableHeight && tableHeight ? { height: tableHeight } : {}),
        ...$attrs,
      },
    }
    const lastColumnScoped = {
      ...$scopedSlots,
    }
    if (this.lastColumnScopedHeader) {
      lastColumnScoped[lastColumn.slotHeaderName] = this.lastColumnScopedHeader
    }
    const paginationData = {
      attrs: Object.assign({ layout: 'total, sizes, prev, pager, next, jumper' }, this.paginationComponentData),
    }
    return (
      <div ref="tableWrap">
        <el-table ref="elTable" data={data} style="width: 100%" {...other} max-height={this.maxHeight}>
          {selection && <el-table-column type="selection" width="55" reserveSelection={true} />}
          {tableColumns.map(item => (
            <z-table-column key={item.label} item={item} scopedSlots={$scopedSlots} />
          ))}
          <template slot="empty">
            <div style="min-height:200px;position:relative">
              <ZDefaultData custom={customDefault}></ZDefaultData>
            </div>
          </template>
        </el-table>
        {pagination !== false && (
          <div class="pagination-container">
            <el-pagination
              currentPage={pagination.pageNum}
              pageSizes={pagination.pageSizes || [10, 20, 50, 100, 200]}
              pageSize={pagination.pageSize}
              background
              total={parseInt(pagination.total)}
              on={{
                'size-change': handlePageSizeChange,
                'current-change': handlePageChange,
              }}
              {...paginationData}
            ></el-pagination>
          </div>
        )}

        {tableName && (
          <el-drawer
            title={this.$t('system::common::editorHeader-table::title')}
            visible={drawer}
            direction={direction}
            custom-class="z-table__drawer"
            size="440px"
            on={{ 'update:visible': closeDrawer }}
          >
            <div class="z-table__drawer__body">
              <span class="z-table__drawer__tip">{this.$t('system::common::editorHeader-table::tip')}</span>
              <div class="z-table__drawer__drag">
                <draggable-list
                  list={totalCheckList}
                  textlist={columns}
                  fixTableHeaderList={this.fixTableHeaderList}
                ></draggable-list>
              </div>
              <div class="z-table__drawer__action">
                <el-checkbox style="margin-bottom:0" value={allColumnConfig} on={{ input: this.changeAllCheck }}>
                  {this.$t('system::common::btn::selecAll')}
                </el-checkbox>
                <div>
                  <el-button size="small" onClick={resetOriginColumnConfig}>
                    {this.$t('system::common::btn::reset')}
                  </el-button>
                  <el-button size="small" type="primary" onClick={confirmColumnConfig}>
                    {this.$t('system::common::btn::confirm')}
                  </el-button>
                </div>
              </div>
            </div>
          </el-drawer>
        )}
      </div>
    )
  },
}
</script>
<style lang="scss" scoped>
.z-table__drawer {
  width: 440px !important;
  background: #f0f2f5;
  padding-top: 80px;
  .el-drawer__header {
    // margin-bottom: 10px;
    // border-bottom: 1px solid $--border-color-base;
    // padding: $--base-padding;
    // font-size: 14px;
    // color: #010517;
    // font-weight: bold;
    // background-color: #fff;
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
  }
  .el-drawer__body {
    height: 100%;
    position: relative;
  }
  &__body {
    padding: 20px 0 64px 0;
    height: 100%;
    box-sizing: border-box;
    // display: flex;
    // flex-direction: column;
  }
  &__tip {
    // color: #999999;
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    padding-left: 16px;
    background: #fff;
    // z-index: 3;
  }
  &__drag {
    overflow: auto;
    height: 100%;
    padding: 0 16px;
  }
  &__action {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    right: 0;
    height: 63px;
    border-top: 1px solid $--border-color-base;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 440px;
    box-sizing: border-box;
    z-index: 999;
  }

  :focus {
    outline: 0;
  }
}

.pagination-container {
  text-align: center;
  margin-top: 16px;

  .el-pagination__total {
    color: #010517;
  }

  .el-pagination__jump {
    color: #010517;
  }
}
</style>
